import { render, staticRenderFns } from "./TicketQuantity.vue?vue&type=template&id=2d624c23&"
import script from "./TicketQuantity.vue?vue&type=script&lang=js&"
export * from "./TicketQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports